import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchAll() {
        return axios.get(`${coreIAMUrl}/scopes`)
    },
    fetchOne(uuid) {
        return axios.get(`${coreIAMUrl}/scopes/${uuid}`);
    },
    createScope(name, description) {
        return axios.post(`${coreIAMUrl}/scopes`, {
            name: name,
            description: description
        });
    },
    updateScope(scopeUuid, name, description) {
        return axios.patch(`${coreIAMUrl}/scopes/${scopeUuid}`, {
            name: name,
            description: description,
        });
    },
    deleteScope(scopeUuid) {
        return axios.delete(`${coreIAMUrl}/scopes/${scopeUuid}`);
    },
    getCurrentRoles(scopeUuid) {
        return axios.get(`${coreIAMUrl}/scopes/${scopeUuid}/current-roles`)
    },
    getAvailableRoles(scopeUuid) {
        return axios.get(`${coreIAMUrl}/scopes/${scopeUuid}/available-roles`)
    },
    addRoleToScope(scopeUuid, roleUuid, roleName) {
        return axios.post(`${coreIAMUrl}/scopes/${scopeUuid}/add-role`, {
            uuid: roleUuid,
            name: roleName,
        })
    },
    removeRoleFromScope(scopeUuid, roleUuid, roleName) {
        return axios.post(`${coreIAMUrl}/scopes/${scopeUuid}/remove-role`, {
            uuid: roleUuid,
            name: roleName,
        })
    },
}
